import { Typography } from "@material-ui/core";
import { useRecordContext } from "react-admin";
import React, { useState } from "react";
import { filter, find } from "lodash";
import AssignmentLinkField from "./AssignmentLinkField";

interface IBusDataField {
  type: string;
  data: IRouteData[];
  label: string;
}

const getRouteNames = (type: string, data: IRouteData[]) => {
  let routeNames: string[] = [];
  switch (type) {
    case "to_school":
      const filteredDataAM = filter(data, { routeType: "to_school" });

      filteredDataAM.map((data: any) => {
        routeNames = [...routeNames, ...data.routeNames];
      });

      return routeNames;
    case "from_school":
      const filteredDataPM = filter(data, { routeType: "from_school" });

      filteredDataPM.map((data: any) => {
        routeNames = [...routeNames, ...data.routeNames];
      });

      return routeNames;
    default:
      return [];
  }
};

const BusDataField = ({ type, data }: IBusDataField) => {
  const routeNames = getRouteNames(type, data);

  return (
    <Typography variant="body2">
      {routeNames.length > 0
        ? routeNames.map((routeName: string, index: number) => (
            <AssignmentLinkField
              routeName={routeName}
              isLastIteration={routeNames.length === index + 1}
            />
          ))
        : "-"}
    </Typography>
  );
};

export default BusDataField;
